import useAuth from "../../login/AuthContext";

import { useNetwork } from "../../../hooks/useNetwork";
import { UpdateNetwork } from "../../../services/NetworkApi";
import { useNetworkContext } from "../../../contexts/NetworkContext/context";

export const useNetworkRename = () => {
  const { getAuthToken } = useAuth();
  const { updateNetworkValues } = useNetworkContext();
  const { selectedNetwork } = useNetwork();

  const handleRename = async (networkName: string) => {
    await UpdateNetwork(
      selectedNetwork.l1Id,
      { networkName, importType: selectedNetwork.importType },
      await getAuthToken()
    );
    return updateNetworkValues(selectedNetwork.l1Id, {
      l1Name: networkName,
    });
  };

  return handleRename;
};
